import { isEmpty } from "lodash";
import en from "./lang/en.json";
import fr from "./lang/fr.json";

const Translate = ({ id, values = [], uppercase = false }) => {
  const transformVariables = response => {
    const re = /(\{{[0-9]+\}})/g;
    const matches = response.matchAll(re);

    if (matches && !isEmpty(values)) {
      let counter = 0;
      for (const match of matches) {
        response = response.replace(match[0], values[counter]);
        counter++;
      }
    }
    return response;
  };

  let locale = localStorage.getItem("locale");
  if (!locale) {
    locale = "en";
    console.info("Locale not set. Setting default locale to 'en'");
  }
  let response;

  switch (locale) {
    case "en":
    default:
      response = en[id];
      break;
    case "fr":
      response = fr[id];
      break;
  }

  response = response || "";
  response = transformVariables(response);
  if (uppercase) {
    response = response.toUpperCase();
  }
  return response;
};

export default Translate;
